import React, { PureComponent } from 'react';
import { isImageFile, getFileExtension, isVideoFile } from '../../../../utils/mediaTypes';
import { selectedWorkItemValue } from './fileAttachmentWorkItems';

function fileIconClass(fileid) {
	const filetype = getFileExtension(fileid);
	if (filetype === 'pdf') return 'fa-file-pdf';
	if (filetype === 'csv' || filetype === 'xls' || filetype === 'xlsx') return 'fa-file-excel';
	if (filetype === 'jpg' || filetype === 'jpeg' || filetype === 'png' || filetype === 'gif') return 'fa-image';
	if (isVideoFile(fileid)) return 'fa-file-video';
	if (filetype === 'doc' || filetype === 'docx') return 'fa-file-word';
	if (filetype === 'txt') return 'fa-file-lines';
	return 'fa-file';
}

class FileAttachmentGrid extends PureComponent {
	renderTile(attachment) {
		const attached = Boolean(selectedWorkItemValue(attachment));
		const isImage = isImageFile(attachment.fileid);
		return (
			<button
				key={`tile_${attachment.id}`}
				type="button"
				className="files-thumb-tile"
				onClick={() => this.props.onOpen(attachment)}
				aria-label={attachment.fileid || `Attachment ${attachment.id}`}
			>
				<div className="thumb">
					{isImage ? (
						<img src={attachment.location} alt="" />
					) : (
						<i className={`fas ${fileIconClass(attachment.fileid)} text-secondary`} />
					)}
					{attached && (
						<span className="wrench" title="Attached to work item" aria-hidden="true">
							<i className="fas fa-wrench" />
						</span>
					)}
				</div>
			</button>
		);
	}

	render() {
		const { attachments } = this.props;
		if (!attachments || !attachments.length) {
			return <p className="text-muted mb-0">No files yet.</p>;
		}
		return (
			<div className="files-thumb-grid">
				{attachments.map(attachment => this.renderTile(attachment))}
			</div>
		);
	}
}

export default FileAttachmentGrid;
